import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { MarketplaceOfferJsonldMarketplaceOfferRead } from '@/api/generated';
import { VARIANT_COLOR_ENUM } from '@/types/utils';
import { useToaster } from 'context/Toaster/ToasterContext';
import { useBuyOfferApi } from 'hooks/queries/marketplace/offers';

type FormValues = { quantity: number };

const useBuyOffer = ({
  closeModal,
  cardOffer,
}: {
  closeModal: () => void;
  cardOffer?: MarketplaceOfferJsonldMarketplaceOfferRead;
}) => {
  const schema = () =>
    yup
      .object({
        quantity: yup
          .number()
          .min(1)
          .max(cardOffer?.quantity || 0)
          .required(),
      })
      .required();

  const formMethods = useForm<FormValues>({
    mode: 'onSubmit',
    defaultValues: {
      quantity: 1,
    },
    resolver: yupResolver(schema()),
  });
  const { handleSubmit, watch } = formMethods;
  const { addToaster } = useToaster();
  const onSuccess = async (message: string) => {
    addToaster({ message, variant: VARIANT_COLOR_ENUM.SUCCESS });
    closeModal();
  };
  const { buyOffer } = useBuyOfferApi(onSuccess);
  const onSubmit = async ({ quantity }: FormValues) => {
    await buyOffer.mutateAsync({
      cardRef: cardOffer!.card!.split('/').pop()!,
      offerId: cardOffer!.offerId!,
      quantity,
    });

    return true;
  };

  const total = watch('quantity') * (cardOffer?.convertedPrice || 0);

  return {
    formMethods,
    onSubmit: handleSubmit(onSubmit),
    closeModal,
    total,
    isLoading: buyOffer.isPending,
  };
};

export default useBuyOffer;
